<template>
  <el-container v-if="ready">
    <el-aside>
      <TopicNav></TopicNav>
    </el-aside>
    <router-view class="Topic" :key="$route.name"></router-view>
  </el-container>
</template>
<script>
/* eslint-disable no-console */
import axios from '../axios'
import { MessageBox } from 'element-ui'
import changerole from '../pub/changerole'
import TopicNav from './TopicNav'

export default {
  name: 'TopicView',
  components: {
    TopicNav,
    changerole
  },
  data () {
    return {
      ready: false
    }
  },
  beforeCreate () {
    axios.get('/is_login/').then(response => {
      if (response.data.roles.indexOf(this.$store.state.role) > -1) {
        this.$store.commit('setLogin', response.data)
        this.ready = true
      } else {
        MessageBox.alert('未登录，请重新登录')
        localStorage.removeItem('Authorization')
        this.$router.push('/login')
      }
    })
  }
}
</script>
